import { UserTypeEnum, TransactionLogStatusEnum, isUserManagementEnabled } from "../constants/appConstant";
import common from "../helper/common";
import {
  DashBoard,
  Calendar,
  User,
  Map,
  Application,
  PretentionChartLine2,
  Settings,
  Graph,
  Stacks2,
  Chart,
  BarLeft,
  Medical,
  Note3,
  Pointer,
  Cart,
  Pages,
  Bell,
  Envelope,
  Messages,
  Grid,
  //UserSearch,
  Users,
  DSearch,
  List,
  Sheild,
} from "../svg";

// ----------- static menu code -----------
export const getStaticMenuConfig = (roleType, isPrivateClub) => {
  debugger
  switch (roleType) {
    case UserTypeEnum.Club_Specific:
      return {
        sidebarNav: {
          classic: [
            {
              title: "dashboard",
              icon: Application,
              href: "/app/dashboard",
            },
            {
              title: "Today's Bookings",
              href: "/app/todaycalendar",
              icon: Calendar,
              isNew: false,
            },

            {
              isHeader: true,
              title: "Booking",
            },

            {
              title: "Bookings",
              icon: Calendar,
              href: "/app/clubbookings",
              isOpen: false,
              isHide: false,
              child: [
                {
                  title: "Booking List",
                  href: "/app/clubbookings",
                  icon: Graph,
                },
                {
                  title: "Booking Calendar",
                  href: "/app/bookingcalendar",
                  icon: Graph,
                },

                {
                  title: "Multi Booking",
                  href: "/app/addmultibooking",
                  icon: Graph,
                  isPremium: true,
                },

                {
                  title: "Calendar",
                  href: "/app/calendar",
                  icon: Graph,
                },
              ],
            },

            ...(!isPrivateClub
              ? [
                  {
                    title: "Customers",
                    icon: User,
                    href: "/app/clubcustomers",
                  },
                ]
              : []),
            ...(isPrivateClub
              ? [
                  {
                    title: "Private Customers",
                    icon: Users,
                    href: "/app/clubusers",
                  },
                ]
              : []),

            ...(global?.myClub?.isfacilitieson
              ? [
                  {
                    isHeader: true,
                    title: "Facility",
                  },

                  {
                    title: "Facility",
                    icon: Map,
                    href: "/app/clubamenities",
                  },

                  {
                    title: "Bookings",
                    href: "/app/amenitybookings",
                    icon: Graph,
                  },

                  // {
                  //   title: "Amenity Bookings",
                  //   icon: Calendar,
                  //   href: "/app/amenitybookings",
                  //   isOpen: false,
                  //   isHide: false,
                  //   child: [],
                  // },
                ]
              : []),

            {
              isHeader: true,
              title: "Accounts",
            },

            {
              title: "Payments",
              icon: PretentionChartLine2,
              href: "#",
              child: [
                {
                  title: "Received",
                  icon: DashBoard,
                  href: `/app/transactions?status=${TransactionLogStatusEnum.Success}`,
                },
                {
                  title: "Refundable",
                  icon: DashBoard,
                  href: `/app/transactions?status=${TransactionLogStatusEnum.Refundable}`,
                },
                {
                  title: "Refunded",
                  icon: DashBoard,
                  href: `/app/transactions?status=${TransactionLogStatusEnum.Refunded}`,
                },
                {
                  title: "Transaction Logs",
                  icon: DashBoard,
                  href: `/app/transactionLogs`,
                },
              ],
            },

            {
              title: "Expenses",
              icon: Pages,
              href: "/app/expenses",
              isPremium: false,
              //badge: <PremiumIcon />
            },
            {
              title: "Balance",
              icon: Graph,
              href: "/app/balance",
            },
            {
              title: "Account Types",
              icon: Stacks2,
              href: "/app/clubAccounts",
            },

            {
              isHeader: true,
              title: "Shop",
            },
            {
              title: "POS",
              icon: Cart,

              href: "/app/pos",
              isOpen: false,
              isPremium: true,
              isNew: true,
              isHide: false,
              child: [
                {
                  title: "New Order",
                  href: "/app/pos",
                  icon: Graph,
                },
                {
                  title: "Orders List",
                  href: "/app/pos-orders",
                  icon: Graph,
                },
                {
                  title: "Stock Logs",
                  href: "/app/stock-logs",
                  icon: Graph,
                },

                {
                  title: "Stock Management",
                  icon: Stacks2,
                  href: "/app/stock",
                },
                {
                  title: "Products",
                  icon: Cart,
                  href: "/app/products",
                },

                {
                  title: "Categories",
                  icon: List,
                  href: "/app/products/categories",
                },
              ],
            },
            {
              isHeader: true,
              title: "Setup",
            },

            {
              title: "Settings",
              icon: Calendar,
              href: "/app/clubbookings",
              isOpen: false,
              isHide: false,
              child: [
                {
                  title: "Courts",
                  icon: Map,
                  href: `/app/courts`,
                },

                {
                  title: "Club Setup",
                  icon: Settings,
                  href: "/app/clubsetup",
                },

                {
                  title: "Off Peak Pricing",
                  icon: Pages,
                  href: "/app/offpeaks",
                  isNew: true,
                },
                {
                  title: "Terms & Condition",
                  icon: List,
                  href: "/app/termsnConditions",
                },
              ],
            },

            {
              title: "Discounts",
              icon: Cart,
              href: "#",
              isOpen: false,
              isHide: false,
              child: [
                {
                  title: "Promo Code",
                  icon: Chart,
                  href: "/app/promocodes",
                },
                {
                  title: "Bank Discounts",
                  icon: DashBoard,
                  href: `/app/bankdiscounts`,
                },
                {
                  title: "Discount Logs",
                  icon: DashBoard,
                  href: `/app/discountlogs`,
                },
              ],
            },

            {
              title: "Holidays",
              icon: Medical,
              href: "/app/clubholidays",
              isOpen: false,
              isHide: false,
              child: [
                {
                  title: "Club Holidays",
                  icon: Medical,
                  href: "/app/clubholidays",
                },
                {
                  title: "Court Holidays",
                  icon: Medical,
                  href: "/app/courHolidays",
                },
              ],
            },

            {
              isHeader: true,
              title: "ledger",
            },

            {
              title: "Receive/Refund Payments",
              icon: Note3,
              href: "/app/payments",
              isPremium: false,
            },

            {
              title: "Booking Adjustments",
              icon: Pointer,
              href: "/app/adjustments",
              isPremium: false,
            },
          ],
        },
      };

    case UserTypeEnum.Super_Admin:
      return {
        sidebarNav: {
          classic: [
            {
              title: "Clubs",
              icon: Grid,
              href: "/app/Clubs",
              isOpen: false,
              isHide: false,
              child: [
                {
                  title: "Club List",
                  href: "/app/clubs",
                  icon: Graph,
                },
              ],
            },

            {
              title: "Bookings",
              icon: Calendar,
              href: "/app/clubbookings",
              isOpen: false,
              isHide: false,
              child: [
                {
                  title: "Booking List",
                  href: "/app/clubbookings",
                  icon: Graph,
                },
              ],
            },

            {
              title: "Tournament",
              icon: PretentionChartLine2,
              href: "#",
              isOpen: false,
              isHide: false,
              child: [
                //{
                //    title: "Tournament List",
                //    icon: DashBoard,
                //    href: "/app/tournaments",
                //},

                {
                  title: "Teaming",
                  icon: DashBoard,
                  href: "/app/tournamentteaming",
                },

                {
                  title: "Grouping",
                  icon: DashBoard,
                  href: "/app/tournamentGrouping",
                },
                {
                  title: "Scheduling",
                  icon: DashBoard,
                  href: "/app/tournamentScheduling",
                },
                {
                  title: "Tournaments",
                  icon: DashBoard,
                  href: "/app/mastertournaments",
                },
              ],
            },

            {
              title: "Sports",
              icon: Stacks2,
              href: "/app/sports",
            },

            {
              title: "Contact Us",
              icon: Messages,
              href: "/app/contactus",
            },

            {
              title: "Sliders",
              icon: Pages,
              href: "/app/sliders",
              //badge: <PremiumIcon />
            },

            {
              title: "Ranking Categories",
              icon: List,
              href: "/app/rankingcategories",
            },
            {
              title: "Ranking Points",
              icon: Pages,
              href: "/app/rankingpoints",
            },

            {
              title: "Account Type",
              icon: Stacks2,
              href: "/app/adminClubAccounts",
            },
            {
              title: "Analytics",
              icon: Graph,
              href: "/app/analytics",
              isNew: true,
            },

            {
              title: "Check User Existance",
              icon: DSearch,
              href: "/app/checkuserexistance",
            },

            {
              title: "Users",
              icon: User,
              href: "/app/users",
              iconStyle: { color: "#64748b" },
            },

            {
              title: "Promo Code",
              icon: Note3,
              href: "/app/promocodes",
            },

            {
              title: "Notification",
              icon: Bell,
              isOpen: false,
              isHide: false,
              child: [
                {
                  title: "System Notification",
                  href: "/app/notification",
                  icon: Graph,
                },
                {
                  title: "User Notification",
                  href: "/app/usernotification",
                  icon: Graph,
                },
                {
                  title: "Notification Configs",
                  href: "/app/notificationconfigs",
                  icon: Graph,
                  isNew: true,
                },
              ],
            },
            {
              title: "Permissions",
              icon: Sheild,
              href: "#",
              isOpen: false,
              isHide: false,
              child: [
                //{
                //    title: "Tournament List",
                //    icon: DashBoard,
                //    href: "/app/tournaments",
                //},

                {
                  title: "Club Permissions",
                  icon: DashBoard,
                  href: "/app/clubpermissions",
                },

                {
                  title: "Master Permissions",
                  icon: DashBoard,
                  href: "/app/masterpermissions",
                },
                {
                  title: "Global Permissions",
                  icon: DashBoard,
                  href: "/app/globalpermissions",
                },
              ],
            },

            {
              isHeader: true,
              title: "Set up",
            },

            {
              title: "Settings",
              icon: Settings,
              href: "#",
              isOpen: false,
              isHide: false,
              child: [
                {
                  title: "Expense Account",
                  icon: Graph,
                  href: "/app/expenseaccounts",
                },

                {
                  title: "Amenities",
                  icon: DashBoard,
                  href: "/app/amenities",
                },

                {
                  title: "Facilities",
                  icon: DashBoard,
                  href: "/app/facilities",
                },

                {
                  title: "Level Threshold",
                  icon: DashBoard,
                  href: "/app/levelthreshold",
                },

                {
                  title: "Countries",
                  icon: DashBoard,
                  href: "/app/countries",
                },

                {
                  title: "States",
                  icon: DashBoard,
                  href: "/app/states",
                },

                {
                  title: "Cities",
                  icon: DashBoard,
                  href: "/app/cities",
                },
              ],
            },

            {
              title: "Banks",
              icon: Settings,
              href: "#",
              isOpen: false,
              isHide: false,
              child: [
                {
                  title: "Banks",
                  icon: DashBoard,
                  href: "/app/banks",
                },

                {
                  title: "Card Types",
                  icon: DashBoard,
                  href: "/app/bankcards",
                },

                {
                  title: "Card Categories",
                  icon: DashBoard,
                  href: "/app/bankcardcategories",
                },
              ],
            },
          ],
        },
      };

      case UserTypeEnum.Others:
      return {
        sidebarNav: {
          classic: [
            {
              title: "Tournament",
              icon: Graph,
              href: "#",
              isOpen: false,
              isHide: false,
              child: [
                {
                  title: "Tournament List",
                  icon: DashBoard,
                  href: "/app/tournaments",
                },

                // {
                //     title: "Grouping",
                //     icon: DashBoard,
                //     href: "/app/tournamentGrouping",
                // },
                {
                  title: "Teaming",
                  icon: DashBoard,
                  href: "/app/tournamentteaming",
                },
                {
                  title: "Scheduling",
                  icon: DashBoard,
                  href: "/app/tournamentScheduling",
                },
              ],
            },
          ],
        },
      };

    default:
      return {
        sidebarNav: {
          classic: [],
        },
      };
  }
};

// ----------- dynamic menu code -----------
const getIcon = (iconName) => {
  const icons = {
    DashBoard,
    Calendar,
    User,
    Map,
    Application,
    PretentionChartLine2,
    Settings,
    Graph,
    Stacks2,
    Chart,
    BarLeft,
    Medical,
    Note3,
    Pointer,
    Cart,
    Pages,
    Bell,
    Envelope,
    Grid,
    //UserSearch,
    Users,
    DSearch,
    List,
    Sheild,
  };
  return icons[iconName] || Grid;
}

const buildSidebarMenu = (permissions) => {
  const tabs = {};
  const itemMap = {};

  permissions.forEach(item => {
    item.child = [];
    itemMap[item.id] = item;
  });

  permissions.forEach(item => {
    if (item.parentId) {
      const parent = itemMap[item.parentId];
      if (parent) {
        parent.child.push(item);
      }
    }
  });

  permissions.forEach(item => {
    if (!item.parentId) {
      const tab = item.menutab || "";
      if (!tabs[tab]) tabs[tab] = [];
      tabs[tab].push(item);
    }
  });

  return tabs;
}

const convertToSidebarNav = (permissions, isPrivateClub) => {
  const tabMap = buildSidebarMenu(permissions);
  const sidebarNav = [];
  const isFacilitiesOn = global?.myClub?.isfacilitieson;

  const normalizePath = (endpoint) => {
    if (!endpoint) return "";
    return endpoint.replace("/app/", "").replace(/^\//, "").split("?")[0];
  };

  const shouldExcludeByClubSettings = (endpoint) => {
    const slug = normalizePath(endpoint);

    // Private vs Public club specific items
    if (isPrivateClub && slug === "clubcustomers") return true; // hide public customers in private club
    if (!isPrivateClub && slug === "clubusers") return true;    // hide private customers in public club

    // Facilities toggle
    if (!isFacilitiesOn && [
      "clubamenities",
      "amenitybookings",
      "amenitybookingdetails",
      "addamenitybooking",
    ].includes(slug)) return true;

    return false;
  };

  for (const [tabTitle, items] of Object.entries(tabMap)) {
    const tabEntries = [];

    const sortedParents = [...items].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

    sortedParents.forEach(item => {
      if (item.isdisplayon != false) {
        if (shouldExcludeByClubSettings(item.endpoint)) return;
        const navItem = {
          title: item.name,
          icon: getIcon(item.icon),
          href: item.endpoint,
          isOpen: false,
          isHide: false,
          isNew: item.isnewfeature === true,
        };

        // Check if any child is premium
        const visibleChildren = (item.child || [])
          .filter(child => child.isdisplayon != false)
          .filter(child => !shouldExcludeByClubSettings(child.endpoint))
          .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

        if (visibleChildren.length) {
           navItem.child = visibleChildren.map(child => {
            //debugger
            const childItem = {
              title: child.name,
              icon: getIcon(child.icon),
              href: child.endpoint,  // if enpoint has some query comming handle it here
              isNew: child.isnewfeature === true,
            };
            if (child.premiumallowed != null) {
              childItem.isPremium = true;
            }
            return childItem;
          });
          
          // Only show premium icon on parent if parent is premium AND no children are premium
          const hasPremiumChild = visibleChildren.some(child => child.premiumallowed != null);
          if (item.premiumallowed != null && !hasPremiumChild) {
            navItem.isPremium = true;
          }
        } else {
          // For leaf nodes (no children), show premium icon if parent is premium
          if (item.premiumallowed != null) {
            navItem.isPremium = true;
          }
        }
        // Only include item if it has visible children or is a leaf
        if (!navItem.child || navItem.child.length > 0) {
          tabEntries.push(navItem);
        }
      }
    });
    if (tabEntries.length > 0) {
      sidebarNav.push({ isHeader: true, title: tabTitle });
      sidebarNav.push(...tabEntries);
    }
  }
  return sidebarNav;
};

// ----------- Combined getMenuConfig for fallback condition-----------
export const getMenuConfig = (roleType, isPrivateClub) => {
  if (isUserManagementEnabled) {
    try {
      const permissions = common.getUser()?.menus || [];
      const dynamicMenu = convertToSidebarNav(permissions, isPrivateClub);
      return {
        sidebarNav: {
          classic: dynamicMenu,
        },
      };
    } catch (err) {
      console.log("Error building menu from permissions:", err);
      return {
        sidebarNav: {
          classic: [],
        },
      };
    }
  } else {
    return getStaticMenuConfig(roleType, isPrivateClub);
  }
};

// Usage / Calls
// const roleId = common.getUser()?.roleId;
const roleType = common.getUser()?.userType;
const isPrivateClub = global?.myClub?.isPrivateClub;
export const menusConfig = getMenuConfig(/*roleId*/roleType, isPrivateClub);
